<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Tipologia"
        v-model="element.type"
        :options="[
          'Valvole termostatiche',
          'Valvole a due vie',
          'Valvole a tre vie'
        ]"
      />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Numero" v-model="element.number" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>